import React, { useState } from "react";

const InputField = ({ icon, stateFunc, stateValue, name }) => {
  const [isFocus, setIsFocus] = useState(false);
  return (
    <div
      className={`w-full p-3 bg-card rounded-md flex items-center justify-center gap-3 ${
        isFocus && "shadow-md"
      }`}
    >
      <i className={`text-xl text-textColor ${isFocus && "text-headingColor"}`}>
        {icon}
      </i>
      <input
        type="text"
        placeholder={name}
        className="outline-none border-none text-lg text-textColor font-semibold w-full"
        value={stateValue}
        onChange={(e) => stateFunc(e.target.value)}
        onFocus={() => setIsFocus(!isFocus)}
        onBlur={() => setIsFocus(!isFocus)}
      />
    </div>
  );
};

export default InputField;
